export default "<iframe height=\"100%\" width=\"100%\" [src]=\"_src\"></iframe>";